import { Doc, Folder } from '@agently/types';
import { createQuery, createSuspenseQuery } from 'react-query-kit';

import { api } from './client';

const getDocs = async () => {
  const { data } = await api.get<{ items: Doc[] }>('/hub/docs');
  return data.items;
};

// Keep hub lists fresh for the session; agent/mobile route loaders refetch on enter.
export const useGetFiles = createSuspenseQuery({
  fetcher: getDocs,
  queryKey: ['hub', 'docs'],
  staleTime: Infinity,
});

// Same cache as `useGetFiles`, for places that must not suspend (Assistant Citations).
export const useGetHubDocs = createQuery({
  fetcher: getDocs,
  queryKey: ['hub', 'docs'],
  staleTime: Infinity,
});

export const useGetFolders = createSuspenseQuery({
  fetcher: async () => {
    const { data } = await api.get<{ items: Folder[] }>('/hub/folders');
    return data.items;
  },
  queryKey: ['hub', 'folders'],
  staleTime: Infinity,
});

export const getPins = async () => {
  const { data } = await api.get<{ items: Doc[] }>('/hub/pins');
  return data.items;
};

export const useGetPins = createSuspenseQuery({
  fetcher: getPins,
  queryKey: ['hub', 'pins'],
  staleTime: Infinity,
});

export const useDownloadFile = createQuery({
  fetcher: async ({ fileId }: { fileId: string }) => {
    const { data } = await api.get<{ downloadLink: string; fileSize: number }>(
      `/hub/files/${fileId}/download`,
    );
    return data;
  },
  queryKey: ['hub', 'files', 'download'],
});
